import { useState } from "react";

/** Löschen mit Sicherheitsabfrage direkt inline statt window.confirm(). */
export default function ConfirmDeleteButton({ onConfirm, label = "Löschen" }: {
  onConfirm: () => Promise<void>; label?: string;
}) {
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!confirming) {
    return <button className="btn ghost sm" onClick={() => setConfirming(true)}>{label}</button>;
  }
  return (
    <span style={{ display: "inline-flex", gap: 6 }}>
      <button className="btn ghost sm" disabled={busy} onClick={() => setConfirming(false)}>Abbrechen</button>
      <button className="btn sm" disabled={busy}
              style={{ background: "var(--crit-soft)", color: "var(--crit)" }}
              onClick={async () => { setBusy(true); await onConfirm(); setBusy(false); setConfirming(false); }}>
        {busy ? "…" : "Wirklich löschen?"}
      </button>
    </span>
  );
}
